var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEmail(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7258 0.00614213C17.6463 -0.00204738 17.5662 -0.00204738 17.4868 0.00614213H1.16059C1.05596 0.00775442 0.952013 0.023444 0.851562 0.0527883L9.27703 8.44327L17.7258 0.00614213Z",
    fill: "#0859A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5885 0.81662L10.0989 9.27124C9.88041 9.48844 9.58484 9.61035 9.27676 9.61035C8.96868 9.61035 8.67312 9.48844 8.45462 9.27124L0.0408154 0.880758C0.0149498 0.975824 0.00123536 1.07378 0 1.1723V12.8338C0 13.1431 0.122862 13.4397 0.341559 13.6584C0.560255 13.8771 0.856871 14 1.16615 14H17.4923C17.8016 14 18.0982 13.8771 18.3169 13.6584C18.5356 13.4397 18.6585 13.1431 18.6585 12.8338V1.1723C18.6538 1.05082 18.6302 0.930807 18.5885 0.81662ZM1.96497 12.8338H1.15449V12L5.39347 7.79606L6.2156 8.6182L1.96497 12.8338ZM17.4807 12.8338H16.6644L12.4137 8.6182L13.2359 7.79606L17.4748 12L17.4807 12.8338Z",
    fill: "#0859A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic-email.442b8185.svg";
export { ForwardRef as ReactComponent };